import { useEffect, useState } from 'react'

/**
 * Web-compatible hook to track page visibility state
 * Replaces React Native's useAppState for web environments
 *
 * @returns 'active' when page is visible, 'background' when hidden
 */
export const usePageVisibility = (): 'active' | 'background' => {
  const [visibility, setVisibility] = useState<'active' | 'background'>(() => {
    if (typeof document === 'undefined') return 'active'
    return document.hidden ? 'background' : 'active'
  })

  useEffect(() => {
    if (typeof document === 'undefined') return

    const handleVisibilityChange = () => {
      setVisibility(document.hidden ? 'background' : 'active')
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return visibility
}
